import { connect } from "react-redux";

import {
  requestConfirmResetPassword,
  requestResetPassword
} from "../../../store/authentication/thunks";
import { setFailureMessage } from "../../../store/authentication/actions";
import ResetPassword from "./ResetPassword";
import { State } from "../../../store/state";

const mapStateToProps = (state: State) => {
  const { authentication } = state;
  return {
    username: authentication.user.username,
    failureMessage: authentication.failureMessage
  };
};

const mapDispatchToProps = {
  requestConfirmResetPassword,
  requestResetPassword,
  setFailureMessage
};

const ResetPasswordContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);

export default ResetPasswordContainer;
